import { Box, Card, TextField, InputAdornment, Button, TableContainer, Table, TableBody, TableRow, TableCell, Backdrop, IconButton, Popover, MenuItem, Typography, Avatar, TablePagination, FormControl, InputLabel, Select, Grid, LinearProgress, Divider, TableHead, CircularProgress } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import ListHeadTable from "../../components/ListHeadTable";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FormComponent from "./Form";
import { useTranslation } from "react-i18next";
import { numberFormat } from "../../utils/nunberFormat";
import TableSearchNotFound from "../../components/tableSearchNotFound";
import { DEFAULT_ROWS_PER_PAGE } from "../../config-global";
import ListToolbar from "../../components/ListToolbar";
import { useProductController } from "./controller";
import { ProductModel } from "../../models/product";
import AddIcon from '@mui/icons-material/Add';
import Pagination from '@mui/material/Pagination';
import { SECONDARY_COLOR, SELECT_BACKGROUND_COLOR, TEXT_HIGHLIGHT_COLOR, TEXT_LIGHT_COLOR, TEXT_TITLE_COLOR } from "../../constants/colors";
import EXPORT_FILE from '../../assets/images/export_file.svg';
import DOWNLOAD_ICON from '../../assets/images/download_icon.svg';
import ACTIVE_PRODUCT_STATISTIC from '../../assets/images/active_product_static.svg';
import INACTIVE_PRODUCT_STATISTIC from '../../assets/images/inactive_product_statistic.svg';
import ALL_PRODUCT_STATISTIC from '../../assets/images/all_product_statistic.svg';
import PRODUCT_NEED_TO_APPROVE_STATISTIC from '../../assets/images/product_need_to_approve.svg';
import { concatenateStrings } from "../../utils/concatenateStrings";
import { convertDateStringToNormalString } from "../../utils/convertDateFormat";
import InfoIcon from '@mui/icons-material/Info';
import { IMAGE_PRODUCTS_ROOT_URL } from "../../constants/imageUrl";
import { EN_ACCEPT_LANGUAGE } from "../../constants/acceptLanguageApi";
import { MasterProductModel } from "../../models/masterProduct";
import ButtonExportCsv from "../../components/ButtonExportCsv";
import { PRODUCT_FOR_UPLOAD_CATEGORIES_HEADER } from "./csvHeaders/productForUploadCategories";
import ButtonUploadCsv from "../../components/ButtonUploadCsv";
import { LoadingButton } from "@mui/lab";
import ProductTabPanel from "./components/tabPanel";
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated";
import { SuppliesMainGroupName } from "../../models/suppliesMain";
import { SuppliesDivisionModel } from "../../models/suppliesDivisionModel";
import { SuppliesCategoryProduct } from "../../models/suppliesCategoryProduct";
import { SuppliesProductSubCategory } from "../../models/suppliesSubCategory";
import StatusChip from "../../components/StatusChip";


const ProductView = () => {
    const { t, i18n } = useTranslation("global");
    const controller = useProductController();
    const tableHeaders: string[] = ["No.", "Product name (Lao)", "Product name (English)", "UOM", "Pack Type", "Item code", "Barcode", "Status", ""];

    return <Box>
        {
            !controller.openForm
                ?
                <>
                    {
                        !controller.loading
                            ?
                            <Box>
                                <Box mb={5} sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                        <Typography variant="h5" fontWeight="bold" color={TEXT_TITLE_COLOR}>{t("masterProduct_page.Master Product Manage")} </Typography>
                                        {/* <TextField onKeyDown={(e: any) => {
                                            if (e.key === "Enter") {
                                                controller.handleFilterDataByItemCode();
                                            }
                                        }} inputRef={controller.searchRef} fullWidth sx={{ maxWidth: 250 }} placeholder={'Search by Item Code'} InputProps={{
                                            startAdornment: (
                                                <InputAdornment sx={{ cursor: 'pointer' }} position="start" onClick={controller.handleFilterDataByItemCode}>
                                                    <SearchIcon />
                                                </InputAdornment>
                                            )
                                        }} size="small" />
                                        <TextField InputProps={{
                                            startAdornment: (
                                                <InputAdornment sx={{ cursor: 'pointer' }} position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            )
                                        }} size="small" onChange={controller.handleSearchProductByBarcode} fullWidth sx={{ maxWidth: 250 }} placeholder="Search product by barcode" /> */}
                                        <TextField onKeyDown={(e: any) => {
                                            if (e.key === "Enter") {
                                                controller.handleSearchProduct();
                                            }
                                        }} value={controller.searchValue} onChange={controller.handleSearch} fullWidth sx={{ maxWidth: 250 }} placeholder={`${t("masterProduct_page.Item code, Name")}`} InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <IconButton onClick={controller.handleSearchProduct}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }} size="small" />
                                    </Box>
                                    {/* <Box>
                                        <img src={EXPORT_FILE} alt="" style={{ width: 20, height: 28, cursor: 'pointer' }} />
                                    </Box> */}

                                </Box>

                                <Box mb={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Box sx={{ backgroundColor: '#C4EAFF', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                                <Box>

                                                    <Typography color="#7A4100" sx={{ mb: 1 }}>{t("masterProduct_page.All products")} </Typography>
                                                    <Typography color="#7A4100" fontWeight="bold" fontSize={32}>{numberFormat(controller.countAllProduct)}{t("masterProduct_page.Products")} </Typography>
                                                </Box>
                                                <Box>
                                                    <img src={ALL_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                                </Box>
                                            </Box>
                                        </Grid>

                                    </Grid>
                                </Box>
                                <Box sx={{ mb: 2, display: 'flex', justifyContent: 'end', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
                                    <LoadingButton onClick={controller.handleAutoUploadAllProductMerchants} variant="contained" color="secondary" sx={{textTransform:'none',color:'white'}}>Auto Upload product merchants</LoadingButton>
                                    <LoadingButton onClick={controller.handleRefreshAllProduct} loading={controller.loadingRefreshProduct} variant="contained" color="secondary" sx={{ color: 'white', textTransform: 'none' }}>{t("masterProduct_page.Refresh Master Product from SBC")}</LoadingButton>
                                    <LoadingButton onClick={controller.handleRefreshProductCategory} loading={controller.loadingRefreshProductCategory} variant="contained" color="secondary" sx={{ color: 'white', textTransform: 'none' }}>{t("masterProduct_page.Refresh Product Categories")}</LoadingButton>
                                    <Box>
                                        <label htmlFor="upload-input-image" style={{ display: 'inline-block', cursor: 'pointer' }}>

                                            <span style={{ marginLeft: '0.5rem', backgroundColor: SECONDARY_COLOR, color: 'white', borderRadius: '8px', padding: "6px 10px 6px 10px" }}>{t("masterProduct_page.Upload Image")} </span>
                                        </label>
                                        <input
                                            id="upload-input-image"
                                            type="file"
                                            accept="image/*"
                                            multiple
                                            onChange={controller.handleUploadImages}
                                            style={{ display: 'none' }}
                                        />
                                    </Box>
                                    <ButtonUploadCsv loading={controller.loadingUploadProductCategories} onChange={controller.handleUploadProductCategories} title={t("masterProduct_page.Upload product categories")} />
                                    <ButtonExportCsv loading={controller.loadingExportCsvButton} onClick={controller.handleExportCsvProductForUploadCategories} buttonRef={controller.buttonExportProductForUploadCategoriesRef} title={t("masterProduct_page.Export product File Csv")} data={controller.dataMasterProductForUploadCategories} filename="product_for_upload_categories.csv" headers={PRODUCT_FOR_UPLOAD_CATEGORIES_HEADER} />
                                </Box>
                                <Box mb={2}>
                                    <ProductTabPanel value={controller.status} onChange={controller.handleStatusChange} />
                                </Box>
                                {/* Category */}
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="main-label-id">{t("masterProduct_page.Master Main Group")}</InputLabel>
                                            <Select
                                                labelId="main-label-id"
                                                id="main-id"
                                                label='Master Main Group'
                                                value={controller.mainGroupValue}
                                                onChange={controller.handleMasterValueChange}
                                            >
                                                <MenuItem value="All">{t("All")}</MenuItem>
                                                {
                                                    controller.dataMasterMainGroups?.map((data: SuppliesMainGroupName) => (
                                                        <MenuItem key={data?.id} value={data?.id}>
                                                            {i18n.language === EN_ACCEPT_LANGUAGE ? data?.main_group_name_en : data?.main_group_name_la}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="division-label-id">{t("masterProduct_page.Master Division")}</InputLabel>
                                            <Select
                                                labelId="division-label-id"
                                                id="division-id"
                                                label='Master Division'
                                                value={controller.divisionValue}
                                                onChange={controller.handleMasterDivisionValueChange}
                                            >
                                                <MenuItem value="All">{t("All")}</MenuItem>
                                                {
                                                    controller.dataMasterDivisions?.map((data: SuppliesDivisionModel) => (
                                                        <MenuItem key={data?.id} value={data?.id}>
                                                            {i18n.language === EN_ACCEPT_LANGUAGE ? data?.division_name_en : data?.division_name_la}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="categories-label-id">{t("masterProduct_page.Master Categories")}</InputLabel>
                                            <Select
                                                labelId="categories-label-id"
                                                id="categories-id"
                                                label='Master Categories'
                                                value={controller.categoryValue}
                                                onChange={controller.handleMasterCategoryValueChange}
                                            >
                                                <MenuItem value="All">{t("masterProduct_page.All")}</MenuItem>
                                                {
                                                    controller.dataMasterCategories?.map((data: SuppliesCategoryProduct) => (
                                                        <MenuItem key={data?.id} value={data?.id}>
                                                            {i18n.language === EN_ACCEPT_LANGUAGE ? data?.category_name_en : data?.category_name_la}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="subCategory-label-id">{t("Master Sub Categories")}</InputLabel>
                                            <Select
                                                labelId="subCategory-label-id"
                                                id="subCategory-id"
                                                label='Master Sub Category'
                                                value={controller.subCategoryValue}
                                                onChange={controller.handleMasterSubCategoryValueChange}
                                            >
                                                <MenuItem value="All">{t("masterProduct_page.All")}</MenuItem>
                                                {
                                                    controller.dataMasterSubCategories?.map((data: SuppliesProductSubCategory) => (
                                                        <MenuItem key={data?.id} value={data?.id}>
                                                            {i18n.language === EN_ACCEPT_LANGUAGE ? data?.sub_category_name_en : data?.sub_category_name_la}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                {/* Table */}
                                {
                                    !controller.loadingFilterData
                                        ?
                                        <Box sx={{ mt: 2 }}>
                                            <TableContainer>
                                                <Table>
                                                    <TableHead sx={{ background: '#F4F6F8' }}>
                                                        <TableRow>
                                                            {
                                                                tableHeaders?.map((item, index) => <TableCell key={index} sx={{ borderBottom: 'none' }}>{item}</TableCell>)
                                                            }

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            controller.rows?.map((row: MasterProductModel, index: number) => {
                                                                const image = IMAGE_PRODUCTS_ROOT_URL + row?.mainImage?.url;
                                                                return (
                                                                    <TableRow hover key={row?.id} tabIndex={-1}>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat((index + 1) + (DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1)))}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                                                <img
                                                                                    src={image}
                                                                                    alt='Product'
                                                                                    style={{ cursor: 'pointer', objectFit: 'contain', borderRadius: 12, width: 50, height: 50 }}
                                                                                    onClick={() => window.open(image)}
                                                                                />
                                                                                <Typography>{row.productNameLa}</Typography>
                                                                            </Box>

                                                                        </TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.productNameEn}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.uomType}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.packType}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.itemcode}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{
                                                                            concatenateStrings(row?.barcodes)
                                                                        }</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}><StatusChip status={row?.isActiveStatus} /></TableCell>
                                                                        <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                            <IconButton size="large" color="inherit" onClick={(e: any) => controller.onOpenMenu(e, row?.id)}>
                                                                                <MoreHorizIcon />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            <Divider sx={{ mt: 1, mb: 1 }} />
                                            {
                                                controller.loadingFetchDataMore
                                                &&
                                                <Box mb={2} mt={2}>
                                                    <LinearProgress />
                                                </Box>
                                            }
                                            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                                <Pagination color="primary" onChange={controller.handlePageChange} page={controller.currentPage} count={controller.countPagination} />
                                            </Box>
                                        </Box>
                                        :
                                        <LinearProgress sx={{ mt: 1, mb: 1 }} />
                                }
                                <Popover
                                    open={Boolean(controller.openMenu)}
                                    anchorEl={controller.openMenu}
                                    onClose={controller.onCloseMenu}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    PaperProps={{
                                        sx: {
                                            p: 1,
                                            width: 140,
                                            '& .MuiMenuItem-root': {
                                                px: 1,
                                                typography: 'body2',
                                                borderRadius: 0.75,
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem onClick={controller.handleClickViewDataButton}>
                                        <InfoIcon />
                                        &nbsp;&nbsp;
                                        {t("masterProduct_page.See Detail")}
                                    </MenuItem>
                                </Popover>
                            </Box>
                            :
                            <>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <LoadingAnimatedIcon />
                                </Box>
                            </>

                    }
                </>
                :
                <FormComponent onRefetchData={controller.handleRefetchData} onClose={controller.onCloseForm} selectedData={controller.selectedData} dataMasterMainGroup={controller.dataMasterMainGroups} dataMasterDivisions={controller.dataMasterDivisions} dataMasterCategories={controller.dataMasterCategories} dataMasterSubCategories={controller.dataMasterSubCategories} dataBrand={controller.dataBrand} setData={controller.setData}/>
        }
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={controller.loadingUploadData}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </Box>

}
export default ProductView;